import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Heart, LayoutGrid, User, ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/cart";
import { useWishlist } from "@/lib/wishlist";
import { useAuth } from "@/lib/auth";

const items = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/wishlist", label: "Wishlist", icon: Heart },
  { to: "/fabrics", label: "Shop", icon: LayoutGrid },
  { to: "/dashboard", label: "Profile", icon: User, authTo: "/auth" },
  { to: "/cart", label: "Cart", icon: ShoppingBag },
];

export default function MobileNav() {
  const { pathname } = useLocation();
  const { cart } = useCart() || { cart: { items: [] } };
  const { count } = useWishlist();
  const { user } = useAuth();
  if (pathname.startsWith("/admin")) return null;
  const cartCount = (cart?.items || []).reduce((n, i) => n + (i.quantity || 1), 0);

  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-black/10 md:hidden" data-testid="mobile-nav" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const to = it.authTo && !user ? it.authTo : it.to;
          const badge = it.label === "Cart" ? cartCount : it.label === "Wishlist" ? count : 0;
          return (
            <NavLink key={it.label} to={to} end={it.end}
              className={({ isActive }) => `relative flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] ${isActive ? "text-black" : "text-[#9CA3AF]"}`}>
              <span className="relative">
                <it.icon size={20} strokeWidth={1.8} />
                {badge > 0 && <span className="absolute -top-1.5 -right-2 min-w-[15px] h-[15px] px-1 rounded-full bg-squire-jeans text-white text-[9px] grid place-items-center">{badge}</span>}
              </span>
              {it.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
